import { Pipe, PipeTransform } from '@angular/core';
import { AlertLog, AlertLogPriority } from '@greco/domain-alert-logs';

@Pipe({ name: 'alertColor' })
export class AlertColorPipe implements PipeTransform {
  transform(value?: AlertLog): string | undefined {
    if (value?.resolved && value.resolved.getTime() < new Date().getTime()) return undefined;

    switch (value?.priority) {
      case AlertLogPriority.HIGH:
        return 'danger';
      case AlertLogPriority.LOW:
        return 'warn';
      case AlertLogPriority.INFO:
      default:
        return 'info';
    }
  }
}
